module.exports = __webpack_public_path__ + "static/media/saveNo.2a0b959f.png";